import { startOfWeekLocale } from 'components/DateRangePicker/mondayBasedLocales';
import addDays from 'date-fns/addDays';
import getDay from 'date-fns/getDay';
import getDaysInMonth from 'date-fns/getDaysInMonth';
import isSameDay from 'date-fns/isSameDay';
import parseISO from 'date-fns/parseISO';
import { Account } from 'model/IChat';
import React from 'react';

import DatePickerDay from './DatePickerDay';

const CSS = require('./DatePickerMonth.module.scss');

const TODAY = new Date();
const START_OF_WEEKDAY = startOfWeekLocale(TODAY);

interface DatePickerMonthProps {
  displayedMonth: Date;
  selectedDay?: Date;
  onDateChange: (newDate: string) => void;
  availableDates?: { date: string; locals?: string[] }[];
  withAvailability?: boolean;
  preferredLocal?: Partial<Account>;
  variant: 'pink' | 'jade';
  isLoading?: boolean;
}

function DatePickerMonth({
  displayedMonth,
  selectedDay,
  onDateChange,
  availableDates,
  withAvailability,
  preferredLocal,
  variant,
  isLoading,
}: DatePickerMonthProps) {
  const startDay = getDay(displayedMonth);
  const startOffset =
    startDay === 0 && getDay(START_OF_WEEKDAY) === 1
      ? 6
      : getDay(displayedMonth) - getDay(START_OF_WEEKDAY);
  const nrOfDaysInMonth = getDaysInMonth(displayedMonth);
  const daysInMonth = Array(nrOfDaysInMonth)
    .fill(0)
    .map((elem, index) => addDays(displayedMonth, index));

  return (
    <ol className={CSS.MonthList} data-loading={isLoading}>
      {Array(startOffset)
        .fill(0)
        .map((x, index) => (
          <li key={`empty-day-${index}`} className={CSS.ListItem} />
        ))}
      {daysInMonth.map((day, index) => {
        const isUnavailable = withAvailability
          ? !availableDates.some(({ date }) => {
              return isSameDay(parseISO(date), day);
            })
          : false;
        const isPreferredAvailable =
          withAvailability && preferredLocal
            ? availableDates.some(({ date, locals = [] }) => {
                return (
                  isSameDay(parseISO(date), day) &&
                  locals.includes(preferredLocal.id)
                );
              })
            : false;
        return (
          <li key={`day-${index}`} className={CSS.ListItem}>
            <DatePickerDay
              day={day}
              selectedDay={selectedDay}
              onDateChange={onDateChange}
              isUnavailable={isUnavailable}
              isPreferredAvailable={isPreferredAvailable}
              variant={variant}
            />
          </li>
        );
      })}
    </ol>
  );
}

export default DatePickerMonth;
